import { Navigate } from 'react-router-dom';
import { useUserRole } from '@/hooks/useUserRole';
import { useUserPermissions } from '@/hooks/useUserPermissions';
import { Loader2, ShieldAlert } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

const ADMIN_ALLOWED_EMAILS = ['cfogaca@divuslegalgroup.com'];

export default function AdminRoute({ children }: { children: React.ReactNode }) {
  const { role, loading } = useUserRole();
  const { permissions } = useUserPermissions();

  if (loading) {
    return (
      <div className="flex items-center justify-center flex-1">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  const currentUserEmail = (permissions?.email || '').toLowerCase();
  const allowedRoles = ['admin'];

  if (!allowedRoles.includes(role || '') && !ADMIN_ALLOWED_EMAILS.includes(currentUserEmail)) {
    return (
      <div className="flex items-center justify-center flex-1 p-4">
        <Card className="max-w-md w-full">
          <CardHeader>
            <div className="flex items-center gap-3">
              <div className="p-3 bg-destructive/10 rounded-full">
                <ShieldAlert className="h-6 w-6 text-destructive" />
              </div>
              <CardTitle>Acesso Negado</CardTitle>
            </div>
          </CardHeader>
          <CardContent className="space-y-4">
            <p className="text-muted-foreground">
              Você não tem permissão para acessar esta página. 
              Apenas usuários autorizados podem visualizar o painel administrativo.
            </p>
            <Button 
              onClick={() => window.history.back()} 
              className="w-full"
            >
              Voltar
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return <>{children}</>;
}
